import { TabPanel, TabView, TabViewTabChangeEvent } from "primereact/tabview";
import { SharedDefectsTable } from "../components/DefectsTable/SharedDefectsTable";
import { useAppDispatch, useAppSelector } from "../hooks/storeHooks";
import { useTableSearchParams } from "../hooks/useTableSearchParams";
import { selectSharedDefectsLoading } from "../store/selectors/sharedDefectsSelectors";
import { useTranslation } from "react-i18next";
import { selectActiveTab } from "../store/selectors/defectSelectors";
import { SharedSummaryTable } from "../components/DefectsTable/SharedSummaryTable";
import { setActiveTab } from "../store/slices/defectSlice";

const SharedDefects = () => {
    const { t } = useTranslation("locale");
    const dispatch = useAppDispatch();

    const loading = useAppSelector(selectSharedDefectsLoading);
    const activeTab = useAppSelector(selectActiveTab);

    useTableSearchParams("shared-defects-table", loading);

    const onTabChange = (e: TabViewTabChangeEvent) => {
        dispatch(setActiveTab(e.index));
    };

    return (
        <TabView renderActiveOnly activeIndex={activeTab} onTabChange={onTabChange} className={"tab-container"}>
            <TabPanel header={t("defectsSummary.defectsSummary")}>
                <SharedSummaryTable isLoading={loading} />
            </TabPanel>
            <TabPanel header={t("defectsTable.defectsOverview")}>
                <SharedDefectsTable  />
            </TabPanel>
        </TabView>
    )
};

export default SharedDefects;